import React from 'react';

// Scrollable pill topic bar + HTML body for the selected topic.
export default function HelpContent({ section, topicId, onSelectTopic }) {
  const topic = section.topics.find((t) => t.id === topicId) || section.topics[0];
  return (
    <>
      <div className="help-pills">
        {section.topics.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`help-pill${t.id === topic.id ? ' is-active' : ''}`}
            onClick={() => onSelectTopic(t.id)}
          >
            {t.title}
          </button>
        ))}
      </div>
      <div className="help-body">
        <h3 className="help-body__title">{topic.title}</h3>
        <div dangerouslySetInnerHTML={{ __html: topic.body }} />
      </div>
    </>
  );
}
